import React from 'react';
import { updateRecord } from '../../../util/formHelper';

function SubmitButtons({ back, saveActionURL, body, onClick, disabled = false }) {
  return (
    <div className="d-flex justify-content-end mt-3">
      <button
        disabled={disabled}
        type="submit"
        className="btn btn-primary btn-sm mr-3"
        onClick={() => {
          if (body.currentCar) {
            const { currentRegistrationMark, currentCarId } = body.currentCar || {};
            if (currentCarId === body.car || currentRegistrationMark === body.registrationMark) {
              alert('Please select/input another Registration Mark');
              return;
            }
          }

          if (onClick && typeof onClick === 'function') {
            onClick(saveActionURL, body);
            return;
          }
          updateRecord(saveActionURL, body);
        }}
      >
        Save
      </button>
      <button type="button" className="btn btn-light btn-sm" onClick={() => back && back()}>
        Cancel
      </button>
    </div>
  );
}

export default SubmitButtons;
